/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Family chip, derived from item status, the participant's own documents and their response
 * @export
 */
export const PortalItemDisplayStatus = {
    ToDo: 'to_do',
    Sent: 'sent',
    NeedsAnotherLook: 'needs_another_look',
    Accepted: 'accepted',
    DoesntApply: 'doesnt_apply',
    CantFind: 'cant_find',
    SomeoneElseHasIt: 'someone_else_has_it',
} as const;
export type PortalItemDisplayStatus = typeof PortalItemDisplayStatus[keyof typeof PortalItemDisplayStatus];


export function instanceOfPortalItemDisplayStatus(value: any): boolean {
    for (const key in PortalItemDisplayStatus) {
        if (Object.prototype.hasOwnProperty.call(PortalItemDisplayStatus, key)) {
            if (PortalItemDisplayStatus[key as keyof typeof PortalItemDisplayStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortalItemDisplayStatusFromJSON(json: any): PortalItemDisplayStatus {
    return PortalItemDisplayStatusFromJSONTyped(json, false);
}

export function PortalItemDisplayStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalItemDisplayStatus {
    return json as PortalItemDisplayStatus;
}

export function PortalItemDisplayStatusToJSON(value?: PortalItemDisplayStatus | null): any {
    return value as any;
}

export function PortalItemDisplayStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PortalItemDisplayStatus {
    return value as PortalItemDisplayStatus;
}

